import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getExtendedNode } from 'chessboard/model/game/get-extended-node';
import { isFirstNodeInLine } from 'model/move/is-first-node-in-line';

/**
 * Create the getRelativeNode method.
 */
export function createGetRelativeNode(context: API.Context) {
  /**
   * Gets the user-specified node as an offset relative to the current one
   */
  return function getRelativeNode(diff: number = 0): Game.Move.Node | Game.Line | null {
    const { game } = context;

    const ids = { ...game.ids() };
    ids.move += diff;

    const line = context.api.getRawLines()[ids.line];

    if (isFirstNodeInLine(ids.move)) {
      return line;
    }

    return getExtendedNode({
      move: line[ids.move],
      startingMoveNumber: game.startingMoveNumber(),
    });
  };
}
